if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        // Detect if this product form uses the custom multi-variant picker
        this.customVariant = this.closest('product-info')?.querySelector('custom-variant');
        // Also check if the custom variant form is a sibling
        if (!this.customVariant) {
          this.customVariant = document.querySelector('custom-variant');
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Multi-variant submission (custom variant picker)
        if (this.customVariant) {
          this.handleMultiVariantSubmit(evt, config);
        } else {
          this.handleSingleVariantSubmit(evt, config);
        }
      }

      /**
       * Standard single-variant add-to-cart
       */
      handleSingleVariantSubmit(evt, config) {
        console.log('Single-variant add-to-cart');
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => this.handleAddToCartResponse(response, formData, evt))
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.finallyHandler(evt);
          });
      }

      /**
       * Multi-variant add-to-cart: collects quantities from custom-quantity-input elements,
       * attaches logo properties, and adds setup-fee / material items.
       */
      async handleMultiVariantSubmit(evt, config) {
        console.log('Multi-variant add-to-cart');
        const qtyInputs = document.querySelectorAll('.custom-quantity-widget');
        const mainItems = [];

        qtyInputs.forEach((input) => {
          const variantId = input.dataset.id;
          const quantity = parseInt(input.querySelector('input').value) || 0;
          if (quantity > 0 && variantId) {
            mainItems.push({ id: Number(variantId), quantity });
          }
        });

        if (mainItems.length === 0) {
          this.submitButton.setAttribute('aria-disabled', false);
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.handleErrorMessage('Please select at least one item.');
          return;
        }

        // Collect logo / material / position data (mirrors reference implementation)
        const isCustomLogo = typeof window.isNeedLogo === 'function' && window.isNeedLogo();
        let fileInput = [];
        let logoSize = '';
        let logoFirst = 'NO';
        let logoFirstProductId = null;
        let selectedValues = '';
        let logoMaterialId = null;
        let logoMaterialName = '';
        let logoDesc = '';

        if (isCustomLogo) {
          // File data
          const fileArray = typeof window.getLogoSizeData === 'function' ? window.getLogoSizeData() : [];
          fileInput = fileArray;
          if (fileArray.length > 0) {
            logoSize = fileArray.map(function(f) {
              return (f.width || '') + 'inch * ' + (f.height || '') + 'inch';
            }).join(',');
          }

          // First-order setup fee
          if (typeof window.isFirstLogo === 'function' && window.isFirstLogo()) {
            logoFirst = 'YES';
            var firstOrderCard = document.querySelector('.custom-logo-option-card.selected[data-target="first-order"]');
            if (firstOrderCard && firstOrderCard.dataset.vid) {
              logoFirstProductId = Number(firstOrderCard.dataset.vid);
            }
          }

          // Positions — store names (used later in mainItems.forEach for properties)
          if (typeof window.getPositionDisplayData === 'function') {
            var posData = window.getPositionDisplayData();
            selectedValues = posData.map(function(p) { return p.name; }).join(',');
          } else if (typeof window.getSelectedPositions === 'function') {
            selectedValues = window.getSelectedPositions().join(',');
          }

          // Material
          var materialCard = document.querySelector('.custom-logo-material-card.selected');
          if (materialCard) {
            if (materialCard.dataset.vid) logoMaterialId = Number(materialCard.dataset.vid);
            if (materialCard.dataset.name) logoMaterialName = materialCard.dataset.name;
          }

          // Description
          var descInput = document.querySelector('.custom-logo-desc');
          if (descInput && descInput.value.trim()) {
            logoDesc = descInput.value.trim();
          }
        }

        // Build all cart items
        const allItems = [];
        var totalMainQty = 0;

        mainItems.forEach(function(item) {
          var properties = {};
          totalMainQty += item.quantity;

          // Attach logo properties to each main item
          if (isCustomLogo) {
            fileInput.forEach(function(f, i) {
              if (f.path) {
                properties['customLogo_' + i] = f.path;
                properties['customLogoSrcName_' + i] = f.pathName || '';
              }
            });
            if (logoSize) properties.logoSize = logoSize;
            properties.logoFirst = logoFirst;
            if (selectedValues) properties.customPosition = selectedValues;
            // Store position images/titles as indexed properties
            if (typeof window.getPositionDisplayData === 'function') {
              var posDataForProps = window.getPositionDisplayData();
              posDataForProps.forEach(function(p, idx) {
                if (p.image) properties['customPosImage_' + idx] = p.image;
                if (p.tabTitle) properties['customPosTitle_' + idx] = p.tabTitle;
              });
            }
            if (logoMaterialName) properties.logoMaterialName = logoMaterialName;
            if (logoDesc) properties.logoDesc = logoDesc;
          }
          console.log('Adding item:', item.id, item.quantity, properties);
          allItems.push({ id: item.id, quantity: item.quantity, properties: properties });
        });

        // Add setup-fee product (first order)
        if (logoFirstProductId) {
          var fileCount = fileInput.length || 1;
          allItems.push({ id: logoFirstProductId, quantity: fileCount, properties: {} });
        }

        // Add material product
        if (logoMaterialId) {
          var logoNum = fileInput.length || 1;
          var selectedCheckboxes = document.querySelectorAll("input[name='custom_logo_position']:checked");
          var selectedCount = selectedCheckboxes.length || 1;
          var materialQty = selectedCount * totalMainQty * logoNum;
          allItems.push({ id: logoMaterialId, quantity: materialQty, properties: {} });
        }

        if (allItems.length === 0) {
          this.submitButton.setAttribute('aria-disabled', false);
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        // Build FormData
        const formData = new FormData();
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(function(s) { return s.id; })
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        allItems.forEach(function(item, idx) {
          formData.append('items[' + idx + '][id]', item.id);
          formData.append('items[' + idx + '][quantity]', item.quantity);
          if (item.properties && Object.keys(item.properties).length > 0) {
            Object.keys(item.properties).forEach(function(key) {
              var val = item.properties[key];
              if (val != null && val !== '' && !(Array.isArray(val) && val.length === 0)) {
                formData.append('items[' + idx + '][properties][' + key + ']', val);
              }
            });
          }
        });

        config.body = formData;
        console.log('Adding items to cart:', allItems);
        console.log('formData to cart:', formData);

        try {
          var response = await fetch(routes.cart_add_url, config);
          var responseData = await response.json();

          if (responseData.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: null,
              errors: responseData.errors || responseData.description,
              message: responseData.message,
            });
            this.handleErrorMessage(responseData.description);
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // Dispatch custom event (matches reference pattern)
          document.dispatchEvent(new CustomEvent('product:added-to-cart', {
            detail: { id: null, quantity: totalMainQty }
          }));

          // Use standard handleAddToCartResponse for rendering
          this.handleAddToCartResponse(responseData, formData, evt);

          // Reset quantity inputs to 0 after successful add (matches reference)
          qtyInputs.forEach(function(input) {
            var elInput = input.querySelector('input');
            if (elInput) {
              setTimeout(function() {
                elInput.value = 0;
                var blurEvent = new Event('blur', { bubbles: true });
                elInput.dispatchEvent(blurEvent);
              });
            }
          });

        } catch (e) {
          console.error(e);
          this.handleErrorMessage('Failed to add items to cart.');
        } finally {
          this.finallyHandler(evt);
        }
      }

      handleAddToCartResponse(response, formData, evt) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
        }
      }

      finallyHandler(evt) {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');

        CartPerformance.measureFromEvent("add:user-action", evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
